import { Component, OnInit, OnDestroy, Input,Output, EventEmitter } from '@angular/core';
import { Subscription } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Router, ActivatedRoute, RouterModule } from "@angular/router";

// import { LabelsGroup } from '@core/objects/labels-group';

// import { AvailableRuleEventElement } from '@app/store/state/settings/rules/rules.state';
import { RuleEvent, AvailableRuleEventElement } from '@app/models/rules';

import { RulesService } from '@app/services/settings/rules.service';
import { SettingsRulesService } from '@app/services/settings/srules.service';

import { AppService } from '@app/services/app/app.service';
import { TitleService } from '@core/services/title.service';

@Component({
    selector: 'settings-rules-main-edit',
    templateUrl: './main-edit.component.html',
    styleUrls: ['./main-edit.component.scss']
})
export class SettingsRulesMainEditComponent implements OnInit, OnDestroy {
    private readonly ACCESS = 'access_setting_rules_access';

    public readonly STATUS_LOADING = 0;
    public readonly STATUS_DONE = 1;

    // public availableEvents: Array<AvailableRule>;
    public ruleId: number = null;
    // public rule: RuleEvent = null;
	public access: boolean = true;
    // public status: number = 0;
    public status: number = 0;
    public breadcrumbs: any = [
        {
            title: "System Settings",
            link: ['/settings']
        },
        {
            title: "Rules",
            link: ['/settings/rules']
        }
    ];
    public titleText: string = "Add New Rule"; //header title of the page
    protected sessionSubscriptor: Subscription;
    protected editingSubscriptor: Subscription;
    protected availableEventsSubscriptor: Subscription;

	constructor(public srulesSrv: SettingsRulesService,
        public rulesSrv: RulesService,
        public app: AppService,
        private title: TitleService,
        private activeRoute: ActivatedRoute,
        private router: Router){}

	ngOnInit(){
        // let title = "Add new Rule - Rules - System settings";

        this.sessionSubscriptor = this.app.getSession().subscribe( (session: any) => {
            this.access = session.options.access.hasOwnProperty(this.ACCESS)? session.options.access[this.ACCESS] : false;
            if (this.access){
                this.srulesSrv.loadAvailableEvents();
            }
        });

        this.editingSubscriptor = this.srulesSrv.selectEditing().subscribe((edit: RuleEvent) => {

            if(edit.id > 0) {
                this.title.set("Edit: "+edit.name+" - Rules - System settings");
                this.titleText = "Editing: " + edit.name;
            }
        });

        this.availableEventsSubscriptor = this.srulesSrv.selectAvailableEvents().subscribe((availables: AvailableRuleEventElement[] ) => {
            if(availables?.length && this.ruleId != null){
                this.srulesSrv.loadRule(this.ruleId);
            }

            this.status = availables?.length > 0? this.STATUS_DONE : this.STATUS_LOADING;
        });

        this.title.set("Add new Rule - Rules - System settings");

        if(this.activeRoute.snapshot.paramMap.has('id')) {
            this.ruleId = +this.activeRoute.snapshot.paramMap.get('id');

            this.title.set("Edit - Rules - System settings");
            this.titleText = "Editing: ... ";
            this.status = this.STATUS_LOADING;
        } 
	}

    ngOnDestroy() {
        this.editingSubscriptor.unsubscribe();
        this.sessionSubscriptor.unsubscribe();
        this.availableEventsSubscriptor.unsubscribe();
    }

    cancel(event){
        this.router.navigate(['/settings/rules']);
    }
}
